/* Progressive enhancements only. Shopify owns pricing, forms and checkout. */
(() => {
  function enhanceCommerce(scope = document) {
    scope.querySelectorAll('[data-catalog-form]').forEach((form) => {
      if (form.dataset.commerceReady) return;
      form.dataset.commerceReady = 'true';
      // A sort/filter change keeps unrelated query parameters, but resets pagination.
      const managedNames = new Set([...form.elements].map((field) => field.name));
      for (const [name, value] of new URLSearchParams(location.search)) {
        if (name === 'page' || name === 'ooowee_rewards' || managedNames.has(name)) continue;
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = value;
        form.append(input);
      }
      const toggle = form.querySelector('[data-filter-toggle]');
      const panel = form.querySelector('[data-filter-panel]');
      if (toggle && panel) {
        toggle.hidden = false;
        panel.hidden = true;
        toggle.addEventListener('click', () => {
          panel.hidden = !panel.hidden;
          toggle.setAttribute('aria-expanded', String(!panel.hidden));
        });
      }
    });
    scope.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.commerceReady) return;
      section.dataset.commerceReady = 'true';
      const select = section.querySelector('[data-variant-select]');
      if (!select) return;
      const gallery = section.querySelector('[data-product-gallery]');
      const mediaLinks = [...section.querySelectorAll('[data-media-link]')];
      const showMedia = (id) => {
        const media = gallery && [...gallery.children].find((item) => item.id === `Media-${id}`);
        if (!media) return;
        const previous = gallery.querySelector('.is-current-media');
        if (previous && previous !== media) {
          previous.querySelectorAll('video').forEach((video) => video.pause());
          // Reset external players so hidden YouTube/Vimeo media cannot keep playing.
          previous.querySelectorAll('iframe').forEach((frame) => { frame.src = frame.src; });
        }
        gallery.classList.add('is-gallery-enhanced');
        [...gallery.children].forEach((item) => {
          const active = item === media;
          item.hidden = !active;
          item.classList.toggle('is-current-media', active);
        });
        mediaLinks.forEach((link) => {
          if (link.dataset.mediaLink === String(id)) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      };
      mediaLinks.forEach((link) => link.addEventListener('click', (event) => { event.preventDefault(); showMedia(link.dataset.mediaLink); }));
      if (mediaLinks.length) showMedia(select.selectedOptions[0]?.dataset.imageId || mediaLinks[0].dataset.mediaLink);
      const picker = section.querySelector('[data-option-picker]');
      const groups = picker ? [...picker.querySelectorAll('[data-option-index]')] : [];
      const variants = [...select.options].map((option) => {
        let values;
        try { values = JSON.parse(option.dataset.optionValues || 'null'); } catch (_) { values = null; }
        return { option, values };
      });
      const canEnhance = groups.length && variants.every((variant) => Array.isArray(variant.values) && variant.values.length === groups.length);
      const status = section.querySelector('[data-variant-status]');
      const announceSelection = () => section.dispatchEvent(new CustomEvent('ooowee:variant-change', { bubbles: true }));
      let chosen = [];
      const paintChoices = () => groups.forEach((group, index) => {
        group.querySelector('[data-selected-option]').textContent = chosen[index] || '';
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const value = button.dataset.optionValue;
          button.setAttribute('aria-pressed', String(value === chosen[index]));
          const available = variants.some((variant) => variant.option.dataset.available === 'true' && variant.values.every((item, i) => item === (i === index ? value : chosen[i])));
          button.classList.toggle('is-unavailable', !available);
          button.setAttribute('aria-label', `${value}${available ? '' : ' — unavailable in this combination'}`);
        });
      });
      const syncSelection = () => {
        const selected = select.selectedOptions[0];
        if (!selected) { announceSelection(); return; }
        if (canEnhance) {
          chosen = variants.find((variant) => variant.option === selected).values.slice();
          paintChoices();
        }
        if (status) status.textContent = selected.dataset.available === 'true' ? '' : 'This option is currently sold out.';
        if (selected.dataset.imageId) showMedia(selected.dataset.imageId);
        announceSelection();
      };
      if (canEnhance) {
        picker.hidden = false;
        select.hidden = true;
        const label = section.querySelector('[data-variant-label]');
        if (label) label.hidden = true;
        picker.addEventListener('click', (event) => {
          const button = event.target.closest('[data-option-value]');
          if (!button) return;
          const index = Number(button.closest('[data-option-index]').dataset.optionIndex);
          chosen[index] = button.dataset.optionValue;
          const variant = variants.find((item) => item.values.every((value, i) => value === chosen[i]));
          if (variant) {
            select.value = variant.option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            select.selectedIndex = -1;
            section.querySelector('[data-add-to-cart]').disabled = true;
            section.querySelector('[data-add-label]').textContent = 'Unavailable';
            if (status) status.textContent = 'This combination is unavailable. Try another option.';
            paintChoices();
            announceSelection();
          }
        });
      }
      select.addEventListener('change', syncSelection);
      syncSelection();
    });
  }
  enhanceCommerce();
  document.addEventListener('shopify:section:load', (event) => enhanceCommerce(event.target));
})();
